import { Link, createFileRoute } from '@tanstack/react-router';
import { StatusBadge } from '../components/StatusBadge.js';
import { Button } from '../components/ui/button.js';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card.js';
import { requireRole } from '../lib/auth-guard.js';
import { trpc } from '../lib/trpc.js';

export const Route = createFileRoute('/worker/assignments')({
  component: WorkerAssignments,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['worker']);
  },
});

function WorkerAssignments() {
  const list = trpc.assignments.listMineAsWorker.useQuery();

  return (
    <div className="min-h-screen p-6 max-w-3xl mx-auto space-y-6">
      <Link to="/worker" className="text-sm text-[var(--muted-foreground)] hover:text-foreground">
        ← Zurück zur Übersicht
      </Link>
      <header className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Meine Einsätze</h1>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Aktuelle &amp; Vergangene Einsätze</CardTitle>
          <CardDescription>
            Übersicht deiner Verplanung und Einsatzorte bei unseren Kunden.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {list.isLoading && <p className="text-sm text-[var(--muted-foreground)]">Lade Einsätze …</p>}
          {list.data?.length === 0 && (
            <p className="text-sm text-[var(--muted-foreground)]">Du bist aktuell keinem Einsatz zugewiesen.</p>
          )}
          {list.data?.map((a) => (
            <div
              key={a.id}
              className="rounded-lg border border-[var(--border)] p-4 space-y-2 bg-[var(--card)]"
            >
              <div className="flex flex-wrap items-center justify-between gap-2">
                <h3 className="font-semibold text-base">
                  {a.clientCompanyName ?? 'Kunden-Einsatz'}
                </h3>
                <StatusBadge status={a.status} />
              </div>
              <div className="grid gap-2 text-sm md:grid-cols-2 text-[var(--muted-foreground)]">
                <div>
                  <span className="font-medium text-foreground">Zeitraum:</span>{' '}
                  {a.startDate ?? '—'} bis {a.endDate ?? 'offen'}
                </div>
                {a.entgeltGroup && (
                  <div>
                    <span className="font-medium text-foreground">Entgeltgruppe:</span>{' '}
                    {a.entgeltGroup}
                  </div>
                )}
                {a.worksiteAddress && (
                  <div className="md:col-span-2">
                    <span className="font-medium text-foreground">Einsatzort:</span>{' '}
                    {a.worksiteAddress} {a.worksiteState ? `(${a.worksiteState})` : ''}
                  </div>
                )}
                {a.roleDescription && (
                  <div className="md:col-span-2">
                    <span className="font-medium text-foreground">Tätigkeit:</span>{' '}
                    {a.roleDescription}
                  </div>
                )}
              </div>
              <div className="pt-2 flex justify-end">
                <Link to="/worker/timesheets">
                  <Button size="sm" variant="outline">
                    Stundenzettel erfassen
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
